package one.healthium.tutorial.navigation

import androidx.compose.runtime.Composable
import com.arkivanov.decompose.extensions.compose.pages.ChildPages
import com.arkivanov.decompose.extensions.compose.pages.PagesScrollAnimation
import one.healthium.tutorial.navigation.screen.TutorialScreenContent

@Composable
fun TutorialContent(component: TutorialComponent) {
    ChildPages(
        pages = component.pages,
        onPageSelected = {},
        scrollAnimation = PagesScrollAnimation.Default,
        pageContent = { _, page ->
            TutorialScreenContent(page)
        }
    )
}